import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';

export const extractMenu = (strapiSections, category) => {
  if (_isEmpty(strapiSections)) return [];

  const items = _get(
    strapiSections.find(s => s.category === category),
    'columns[0].items',
    []
  );

  if (_isEmpty(items)) return [];

  return items
    .filter(({itemType}) => itemType === 'Page Entry')
    .slice(0, 10)
    .map(({id, itemUrl: link, itemTitle: text, showFooter}) => ({
      id: String(id),
      link: link || '',
      text,
      showFooter,
    }));
};
